interface DataItemStyle {
  [key: string]: number;
}

export default {
  timeHour: 0x1108,
  timeHourLow: 0x1109,
  timeHourHigh: 0x110a,
  timeMinute: 0x1110,
  timeMinuteLow: 0x1111,
  timeMinuteHigh: 0x1112,
  timeSecond: 0x1118,
  timeSecondLow: 0x1119,
  timeSecondHigh: 0x111a,
  timeCentiSecond: 0x1120,
  timeCentiSecondLow: 0x1121,
  timeCentiSecondHigh: 0x1122,
  timeHour12H: 0x1128,
  timeHour24H: 0x1130,

  dateYear: 0x1208,
  dateYearDigit1: 0x1209,
  dateYearDigit2: 0x120a,
  dateYearDigit3: 0x120b,
  dateYearDigit4: 0x120c,
  dateMonth: 0x1210,
  dateMonthLow: 0x1211,
  dateMonthHigh: 0x1212,
  dateDay: 0x1218,
  dateDayLow: 0x1219,
  dateDayHigh: 0x121a,
  dateWeek: 0x1220,
  dateLunarYear: 0x1228,
  dateLunarMonth: 0x1230,
  dateLunarMonthLow: 0x1231,
  dateLunarMonthHigh: 0x1232,
  dateLunarDay: 0x1238,
  dateLunarStringYear: 0x1240,
  dateLunarStringMonth: 0x1248,
  dateLunarStringDay: 0x1250,

  dateWeekStringShortCN: 0x1258,
  dateWeekStringFullCN: 0x1259,
  dateWeekStringFullPascalEN: 0x125a,
  dateWeekStringFullUpperEN: 0x125b,
  dateWeekStringFullLowerEN: 0x125c,
  dateWeekStringShortPascalEN: 0x125d,
  dateWeekStringShortUpperEN: 0x125e,
  dateWeekStringShortLowerEN: 0x125f,

  dateMonthStringShortCN: 0x1260,
  dateMonthStringFullPascalEN: 0x1261,
  dateMonthStringFullUpperEN: 0x1262,
  dateMonthStringFullLowerEN: 0x1263,
  dateMonthStringShortPascalEN: 0x1264,
  dateMonthStringShortUpperEN: 0x1265,
  dateMonthStringShortLowerEN: 0x1266,
  dateSexagenaryCycle: 0x1268,

  // miscIsAM: 0x1308,弃用
  miscIsPM: 0x1310,
  miscIs24H: 0x1318,
  miscTimeSection: 0x1320,
  miscdateTomorrow: 0x1328,
  miscdateYestarday: 0x1330,
  miscdateDayAfterTomorrow: 0x1338,
  miscdateDayBeforeYestarday: 0x1340,
  miscdateTomorrowWeak: 0x1348,
  miscdateYestardayWeak: 0x1350,
  //双时区
  dualtimeHour: 0x1408,
  dualtimeHourLow: 0x1409,
  dualtimeHourHigh: 0x140a,
  dualtimeMinute: 0x1410,
  dualtimeMinuteLow: 0x1411,
  dualtimeMinuteHigh: 0x1412,
  dualtimeSecond: 0x1418,
  dualtimeSecondLow: 0x1419,
  dualtimeSecondHigh: 0x141a,
  dualtimeIsPM: 0x1420,
  dualtimeHour12H: 0x1428,
  dualtimeHour24H: 0x1430,
  dualtimeStringCity: 0x1438,
  dualtimeCity: 0x1440,

  healthStepCount: 0x2108,
  healthStepCountDigit1: 0x2109,
  healthStepCountDigit2: 0x210a,
  healthStepCountDigit3: 0x210b,
  healthStepCountDigit4: 0x210c,
  healthStepCountDigit5: 0x210d,
  healthStepProgress: 0x2110,
  healthStepKiloMeter: 0x2118,
  healthStepTarget: 0x2120,
  healthHeartRate: 0x2208,
  healthHeartRateZone: 0x2210,
  healthHeartRateMin: 0x2218,
  healthHeartRateMax: 0x2220,
  // healthCalorie: 0x2308,弃用
  //卡路里
  healthCalorieValue: 0x2308,
  healthCalorieValueDigit1: 0x2309,
  healthCalorieValueDigit2: 0x230a,
  healthCalorieValueDigit3: 0x230b,
  healthCalorieValueDigit4: 0x230c,
  healthCalorieValueDigit5: 0x230d,
  healthCalorieProgress: 0x2310,
  healthCalorieTarget: 0x2318,
  //站立次数
  healthStandCount: 0x2408,
  healthStandCountDigit1: 0x2409,
  healthStandCountDigit2: 0x240a,
  healthStandProgress: 0x2410, // 站立完成度
  healthStandTarget: 0x2418,
  healthOxygenSpO2: 0x2508,
  healthPressureIndex: 0x2608,
  healthBloodDiastolicPressureMmhg: 0x2708, // 血压-舒张压，单位mmHg
  healthBloodSystolicPressureMmhg: 0x2710, // 血压-收缩压，单位mmHg
  healthBloodDiastolicPressureKpa: 0x2718, // 血压-舒张压，单位kPa
  healthBloodSystolicPressureKpa: 0x2720, // 血压-收缩压，单位kPa
  healthBloodPressureUnit: 0x2728, // 血压单位, 0:mmHg,1:kPa

  healthSleepDuration: 0x2808,
  healthSleepScore: 0x2810,
  healthSleepTargetProgress: 0x2818,
  healthSleepQuality: 0x2820,
  healthSleepTarget: 0x2828,
  healthSleepHRV: 0x2830,
  // 中高强度锻炼时长
  healthExerciseDuration: 0x2908,
  healthExerciseDurationDigit1: 0x2909,
  healthExerciseDurationDigit2: 0x290a,
  healthExerciseDurationDigit3: 0x290b,
  healthExerciseProgress: 0x2910, //中高强度锻炼完成度
  healthExerciseTarget: 0x2918,
  healthEnergyConsumed: 0x2a08,
  healthMiscRecoveryTime: 0x2b08, //恢复时间
  healthMiscRunPowerIndex: 0x2b10, //跑力时长
  // healthMiscTodayVitalityValue: 0x2b18, // 今日元气值 0~80
  // healthMiscSevenDaysVitalityValue: 0x2b20, // 近7日累积元气值，0~560
  healthBloodSugarValue: 0x2c08, //血糖值 0～25.0 单位mmol/L
  healthBloodSugarUpdateTsString: 0x2c10, //血糖更新时间，字符串

  weatherTemperatureUnit: 0x3108, // 温度单位, 0:摄氏度, 1:华氏度
  weatherCurrentTemperatureFeel: 0x3118,
  weatherCurrentTemperature: 0x3120, // 温度 摄氏度
  weatherCurrentHumidity: 0x3128, //湿度
  weatherCurrentWeather: 0x3130,
  weatherCurrentWindAngle: 0x3138,
  weatherCurrentWindSpeed: 0x3140,
  weatherCurrentWindLevel: 0x3148,
  weatherCurrentAirQualityIndex: 0x3150, //空气质量指数
  weatherCurrentAirQualityLevel: 0x3158,
  weatherAirQualityLevel: 0x3158,
  weatherCurrentChanceOfRain: 0x3160,
  weatherCurrentPressure: 0x3168,
  weatherCurrentVisibility: 0x3170,
  weatherCurrentUVIndex: 0x3178,
  weatherCurrentDressIndex: 0x3180,
  weatherCurrentDrivePlateRestriction: 0x3188,
  weatherCurrentAlert: 0x3190,
  weatherCurrentAlertLevel: 0x3198,
  weatherCurrentUpdateTime: 0x31a0,
  weatherCurrentWindDirection: 0x31a8, //风向
  weatherCurrentSunRiseHour: 0x31b0, // 日出时间 小时部分, 对于弧形图只用到 小时部分
  weatherCurrentSunRiseMinute: 0x31b8, // 日出时间 分钟部分
  weatherCurrentSunSetHour: 0x31c0, // 日落时间 小时部分，对于弧形图只用到小时部分
  weatherCurrentSunSetMinute: 0x31c8, // 日落部分 分钟部分
  weatherCurrentTemperatureFahrenheit: 0x31d0, // 温度 华氏度
  weatherCurrentSunRise: 0x31d8, //当日日出时间
  weatherCurrentSunSet: 0x31e0, //当日日落时间
  weatherTodayTemperatureMax: 0x3218, // 最高温度 摄氏度
  weatherTodayTemperatureMin: 0x3220, // 最低温度 摄氏度
  weatherTodayTemperatureMaxFahrenheit: 0x3268, // 最高温度 华氏度
  weatherTodayTemperatureMinFahrenheit: 0x3270, // 最低温度 华氏度
  weatherTodayWeatherColorFull: 0x3278, // 天色完整版
  weatherTodayWeatherColorLite: 0x3280, // 天色精简版
  weatherTomorrowTemperatureMax: 0x3318, // 明日最高温度 摄氏度
  weatherTomorrowTemperatureMin: 0x3320, // 明日最低温度 摄氏度
  weatherTomorrowTemperatureMaxFahrenheit: 0x3368, // 明日最高温度 华氏度
  weatherTomorrowTemperatureMinFahrenheit: 0x3370, // 明日最低温度 华氏度

  // TBD
  weatherTomorrowWeatherFrom: 0x3128,
  weatherTomorrowWeatherTo: 0x3130,
  weatherTomorrowWindDirectionFrom: 0x3138,
  weatherTomorrowWindDirectionTo: 0x3140,
  weatherTomorrowWindSpeedFrom: 0x3148,
  weatherTomorrowWindSpeedTo: 0x3150,
  weatherTomorrowAirQualityIndex: 0x3158,
  weatherTomorrowChanceOfRain: 0x3160,

  systemStatusBattery: 0x4108,
  systemStatusCharge: 0x4110,
  systemStatusDisturb: 0x4118, // 勿扰状态， 0：未开启， 1：已开启
  systemStatusBluetooth: 0x4120, // 蓝牙状态 0：未连接，1：正在连接 2：已连接
  systemStatusWifi: 0x4128, // WIFI状态，0：未连接，1：已连接
  systemStatusScreenLock: 0x4130, // 屏幕LOCK，0：屏幕已解锁，1：屏幕已锁定
  systemStatusVolume: 0x4138,
  systemSensorFusionAltitude: 0x4208,
  appAlarmHour: 0x5108, // 闹钟小时部分
  appAlarmMinute: 0x5110, //闹钟分钟部分
  systemSensorCompass: 0x4250, // 指南针角度
  systemSensorAtmosphericPressure: 0x4258, // 气压
  appSportNoFlyTime: 0x5208, // 禁飞时间，时间部分
  appSportNoFlyTimeUnit: 0x5210, // 禁飞时间，单位部分
  appSportSitTime: 0x5218, // 水面间隔时间，时间部分
  appSportSitTimeUnit: 0x5220, // 水面间隔时间，单位部分

  miscdateDayThreeDaysAgo: 0x1358,
  miscdateDayThreeDaysFromNow: 0x1360,
  dateMoon: 0x1270,
  dateMoonTomorrow: 0x1278,
  dateMoonAfterTomorrow: 0x1280,
  dateMoonThreeTomorrow: 0x1288,
  dateMoonFourDaysAgo: 0x1290,
  dateMoonFiveDaysAgo: 0x1298,
  dateMoonSixDaysAgo: 0x12a0,
  appSportTrainingStatus: 0x5228,
  appSportTrainingLoad: 0x5230,
  appSportRecoveryTime: 0x5238,
  appSportRunPowerIndex: 0x5240,
  appSportOxygenUpdateMax: 0x5248,
  // appSportWeeklyLoadScore: 0x5250,
  appSportRecoveryPercentage: 0x5258,
  healthOxygenSpO2Max: 0x2510,
  healthOxygenSpO2Min: 0x2518,
  healthPressureMax: 0x2610,
  healthPressureMin: 0x2618,
  healthMenstrualCountdown: 0x2d08,
  healthUVA: 0x2e08, // 紫外线UVA
  healthUVB: 0x2e10, // 紫外线UVB

  systemScreenStatus: 0x4140, // 屏幕状态，0：灭屏，1：AOD， 2:亮屏
  systemSensorWristRoll: 0x5108, // 手腕翻滚角，绕X轴旋转
  systemSensorWristPitch: 0x5110 // 手腕俯仰角，绕Y轴旋转
} as DataItemStyle;
